module.exports = __webpack_public_path__ + "acb3371b8edb1ac356e5b83f06e7331a.pdf";